<template>
    <v-card class="mx-auto" min-width="500">

        <v-card-title class="text-h6 font-weight-regular justify-space-between">
        <span>Τιμολόγηση Δελτίων Αποστολής</span>
        </v-card-title>

        <!-- ΕΠΙΛΟΓΗ ΔΕΛΤΙΩΝ -->

        <v-window v-model="step">

            <v-window-item :value="0">
                <v-card-text>
                    <h3 class="text-h6 font-weight-light mb-4">Επιλογή Πελάτη</h3>

                    <v-select
                        v-bind:items="accounts" 
                        v-model="selectedAccount"
                        return-object
                        item-text="name" 
                        label="Πελάτης">
                    </v-select>

                    <h3 class="text-h6 font-weight-light mb-4">Επιλογή Δελτίων</h3>

                   <v-data-table no-data-text="Δεν υπάρχουν δεδομένα"
                    :headers="tableHeaders"
                    :items="tableEntries"
                    :sort-by="['issue_date', 'document_number']"
                    class="elevation-1"
                    disable-pagination
                    hide-default-footer
                    v-model="selectedRows"
                    show-select>
                    <template v-slot:item.documentInfo="{ item }" >
                        {{ item.series.fullName }} #{{ item.document_number }}
                    </template>

                    <template v-slot:item.documentTotal="{ item }" >
                        € {{ item.lines.map(x => makeCurrency(x.net_value - x.discount_value)).reduce((a, b) => a.add(b), makeCurrency(0)) }}
                    </template>
                    </v-data-table>
                </v-card-text>
            </v-window-item>

            <v-window-item :value="1">
                <v-card-text>
                    <h3 class="text-h6 font-weight-light mb-4">Παραστατικό τιμολόγησης</h3>
                    
                    <v-select 
                        v-bind:items="documentTypes" 
                        v-model="selectedDocumentType"
                        return-object
                        
                        item-text="description" 
                        label="Είδος παραστατικού"
                        v-bind:error-messages="allerrors.document_type_id">
                    </v-select>

                    <v-select 
                        v-show="selectedDocumentType.series.length > 1 || (selectedSeries.name && selectedSeries.name.length > 0)"
                        v-bind:items="selectedDocumentType.series"
                        v-model="selectedSeries"
                        return-object
                        item-text="name"
                        item-value="id" 
                        label="Σειρά παραστατικού"
                        v-bind:error-messages="allerrors.document_series">
                    </v-select>

                    <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="document_issue_date"
                                label="Ημερομηνία έκδοσης"
                                append-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on">
                            </v-text-field>
                        </template>
                        <v-date-picker
                            v-model="document_issue_date"
                            @input="menu2 = false">
                        </v-date-picker>
                    </v-menu>


                </v-card-text>
            </v-window-item>



            <v-window-item :value="2">
                <v-card-text>
                    <h3 class="text-h6 font-weight-light mb-4">Μερικό σύνολο: {{totalChargedAmount}}</h3>

                    <v-select
                        v-if="selectedDocumentTypeIsPayable"
                        v-bind:items="filteredPaymentTypes" 
                        v-model="selectedPaymentType"
                        return-object
                        
                        item-text="description" 
                        label="Τρόπος πληρωμής"
                        v-bind:error-messages="allerrors.payment_type_id">
                    </v-select>

                   <v-data-table no-data-text="Δεν υπάρχουν δεδομένα"
                        :headers="itemsHeaders"
                        :items="items"
                        sort-by="calories"
                        class="elevation-1"
                        disable-pagination
                        disable-filtering
                        hide-default-footer>
                        
                        <template v-slot:top>
                            <v-toolbar flat>
                                <v-toolbar-title>Εμπορεύματα</v-toolbar-title>
                                <v-divider class="mx-4" inset vertical></v-divider>
                                <v-spacer></v-spacer>
                                <v-dialog v-model="dialog" max-width="500px">
                                    <v-card>
                                        <v-card-title>
                                            <span class="text-h5">{{ formTitle }}</span>
                                        </v-card-title>

                                        <v-card-text>
                                            <v-container>
                                                <v-row>
                                                    <v-col cols="12" md="8" sm="6">
                                                        <v-text-field
                                                            label="Δελτίο"
                                                            v-model="editedItem.document"
                                                            readonly
                                                        />


                                                        <v-text-field
                                                            label="Είδος"
                                                            v-model="editedItem.product.description"
                                                            readonly
                                                        />

                                                        <v-text-field
                                                            label="Ποσότητα"
                                                            v-model.number="editedItem.quantity"
                                                            track-color="grey"
                                                            always-dirty
                                                            
                                                            readonly>
                                                        </v-text-field>

                                                        <vuetify-money
                                                            v-model="editedItem.unit_price"
                                                            label="Χρέωση μονάδας"
                                                            v-bind:options="moneyFieldOptions">
                                                        </vuetify-money>

                                                        <v-text-field
                                                            label="Εκπτωση (%)"
                                                            v-model.number="editedItem.discount_percentage"
                                                            track-color="grey"
                                                            always-dirty
                                                            min="0"
                                                            max="100"
                                                            thumb-label="always"
                                                            type="number">
                                                        </v-text-field>

                                                        <!-- <vuetify-money
                                                            v-model="editedItem.discount_percentage"
                                                            label="Εκπτωση (%)"
                                                            v-bind:options="discountFieldOptions">
                                                        </vuetify-money> -->
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-card-text>

                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="warning darken-1" text @click="close">ΑΚΥΡΟ</v-btn>
                                            <v-btn color="blue darken-1" text @click="save(true)" v-bind:disabled="lineEntryIncomplete">ΕΝΤΑΞΕΙ</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>

                                
                            </v-toolbar>
                        </template>
                        
                        <template v-slot:[`item.product_code`]="{ item }" >
                            {{ item.isAdHoc ? '-' : item.product.code }}
                        </template>


                        <template v-slot:[`item.product_description`]="{ item }" >
                            {{ item.override_product_description ? item.override_product_description : item.product.description }}
                        </template>

                        <!-- <template v-slot:[`item.product_description`]="{ item }" >
                            {{ (item.product_id ?? 0) == 0 ? item.override_product_description : item.product.description }}
                        </template> -->

                        
                        <template v-slot:[`item.total_price`]="{ item }" >
                            {{ item.total_price.toFixed(2) }}
                        </template>

                        <template v-slot:[`item.discount`]="{ item }" >
                            {{ item.discount > 0 ? item.discount.toFixed(2) : '-' }}
                        </template>

                        <template v-slot:[`item.actions`]="{ item }">
                            <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
                        </template>
                    </v-data-table>

                    
                </v-card-text>

            </v-window-item>

            <v-window-item :value="3">
                <v-card-text>
                    <h3 class="text-h6 font-weight-light mb-4">Παρατηρήσεις - Σχόλια</h3>

                    <v-text-field
                        v-model="comments"
                        label="Παρατηρήσεις">
                    </v-text-field>

                    <v-textarea
                        v-model="comments2"
                        label="Σχόλια">
                    </v-textarea>
                    
                </v-card-text>

            </v-window-item>

            <v-window-item :value="4">
                <v-card-text>
                    <h3 class="text-h6 font-weight-light mb-4">Συνοψη παραστατικού</h3>
                    
                    <v-text-field
                        readonly 
                        v-model="selectedDocumentType.description" 
                        label="Παραστατικό">
                    </v-text-field>

                    <v-text-field
                        readonly 
                        v-model="document_issue_date" 
                        label="Ημερομηνία">
                    </v-text-field>

                    <v-text-field
                        readonly 
                        v-model="selectedAccount.name"
                        label="Πελάτης">
                    </v-text-field>

                    <v-text-field
                        readonly 
                        v-model="totalChargedAmountSummary" 
                        label="Καθαρές χρεώσεις">
                    </v-text-field>

                    <div class="text-center">
                        <v-btn 
                            color="success" 
                            @click="saveDocument" 
                            v-bind:loading="saveDocumentButtonDisabled">
                            ΑΠΟΘΗΚΕΥΣΗ
                        </v-btn>
                    </div>
                </v-card-text>

            </v-window-item>


        </v-window>

        <v-card-actions>
            <v-btn
                v-bind:disabled="step <= 0"
                text
                v-on:click="step--"
                color="primary">
                ΠΙΣΩ
            </v-btn>
            <v-spacer></v-spacer>
            <v-item-group
                v-model="step"
                class="text-center"
                mandatory>
                <v-item
                        v-for="n in totalSteps"
                        v-bind:key="`btn-${n}`"
                        v-slot="{ active, toggle }">
                    <v-btn
                        v-bind:input-value="active"
                        icon
                        dense
                        x-small
                        disabled
                        @click="toggle">
                        <v-icon color="blue">mdi-record</v-icon>
                    </v-btn>
                </v-item>
            </v-item-group>

            <v-spacer></v-spacer>
            <v-btn
                v-bind:disabled="(step >= totalSteps - 1) || (stepCompleted == false)"
                color="primary"
                depressed
                @click="nextStep">
                ΕΠΟΜΕΝΟ
            </v-btn>
        </v-card-actions>


    </v-card>

</template>

<script>
import goTo from 'vuetify/lib/services/goto'
import currency from "currency.js"

export default {
    data () {
        return {
            accounts: [],
            documents: [],

            selectedAccount: {},
            selectedRows: [],
            
            tableHeaders: [
                { 
                    text: 'Έκδοση',
                    align: 'center', 
                    value: 'issue_date', 
                },
                { 
                    text: 'Παραστατικό',
                    align: 'center', 
                    value: 'documentInfo', 
                },
                {
                    text: 'Διακριτικός',
                    value: 'customer.trade_name',
                    align: 'start'
                },
                { 
                    text: 'Υποκατάστημα πελάτη',
                    align: 'center', 
                    value: 'account_branch.name', 
                },

                {
                    text: 'Διανομέας',
                    value: 'account_branch.distributor',
                    align: 'start'
                },

                { 
                    text: 'Διεύθυνση',
                    align: 'center', 
                    value: 'account_branch.address', 
                },
                { 
                    text: 'Αξία δελτίου',
                    align: 'right', 
                    value: 'documentTotal', 
                },


            ],

            moneyFieldOptions: {
                locale: "el-GR",
                prefix: "€",
                suffix: "",
                length: 12,
                precision: 4
            },

            discountFieldOptions: {
                locale: "el-GR",
                prefix: "",
                suffix: "%",
                length: 4,
                precision: 2
            },

            step: 0,
            totalSteps: 5,
            menu2: false,
            saveDocumentButtonDisabled: false,
            
            allerrors : {
                customer: {},
            },

            documentTypes: [],
            documentSeries: [],
            paymentTypes: [],
            charges: [],

            products: [],

            productLines: [],

            selectedDocumentType: {
                series: [],
                charges: []
            },

            selectedSeries: {},

            filteredDocumentSeries: [],

            document_number: '',
            document_issue_date: '',

            comments: '',
            comments2: '',
            

            selectedPaymentType: {},

            dialog: false,
            dialogDelete: false,

            items: [],
            itemsHeaders: [
                {
                    text: 'ΔΑΠ',
                    value: 'document',
                    align: 'start'
                },
                {
                    text: 'Κωδικός',
                    value: 'product_code',
                    align: 'start'
                },
                {
                    text: 'Περιγραφή',
                    value: 'product_description',
                    align: 'start'
                },
                {
                    text: 'Ποσότητα',
                    value: 'quantity',
                    align: 'start'
                },
                {
                    text: 'Καθαρή αξία',
                    value: 'total_price',
                    align: 'start'
                },
                {
                    text: 'Έκπτωση',
                    value: 'discount',
                    align: 'start'
                },
                { text: 'Actions', value: 'actions', sortable: false },
            ],
            formTitle: '',
            editedItem: {
                product: {}
            },
            editedIndex: -1,
            defaultItem: {
                isAdHoc: false,
                quantity: 0,
                unit_price: '',
                discount_percentage: 0.00,
                override_product_vat_category_id : null,
                override_product_tax_withholding_category_id: null,
                override_product_income_category_id: null,
                override_product_measurement_unit_id: null,
                total_price: 0,
                discount: 0,
                discount_percentage: 0,
                product: {}
            },

            disabledTaxRegistrationNumberFields : {
                customer: false
            }
        }
    },

    created() {
        this.initialize()
    },

    watch: {
        step: function (newValue) {
            
        },

        selectedAccount: function () {
            this.selectedRows = []
        },

        selectedDocumentType: function (val) {
            this.document_number = ''
            this.selectedSeries = {}

            if (this.selectedDocumentType.series.length == 1)
                this.selectedSeries = this.selectedDocumentType.series[0]

        },

        selectedProductId: function (newValue) {
            if (newValue)
            {

                if (this.editedIndex >= 0)
                    return

                let suggestedPrice = this.products.find(x => x.id == newValue).suggested_price ?? 0

                if (suggestedPrice > 0 == false)
                    this.editedItem.unit_price = '';
                else
                    this.editedItem.unit_price = suggestedPrice 
            }
        },

        dialog: function (newValue) {
            if (newValue == false)
                this.editedItem = Object.assign({}, this.defaultItem)
        }

    },

    computed: {

        tableEntries() {
            if (this.selectedAccount?.id == null)
                return []

            return this.documents?.filter(x => x.account_id == this.selectedAccount.id)
        },

        selectedProductId() {
            if (this.editedItem == null)
                return null

            return this.editedItem.product_id
        },

        filteredCustomerCities() { return [] },
        
        selectedDocumentTypeDescription () { 
            if (this.document_type_id && this.documentTypes.length > 0)
                return this.documentTypes.find(x => x.id == this.document_type_id).description

            return ''
        },

        selectedDocumentTypeIsPayable() {
            return (this.selectedDocumentType.payable == true);
        },

        totalChargedAmount() {
            const reducer = (a, b) => (currency(a).add(b))
            const sum = this.items.map(x => x.total_price - x.discount).reduce(reducer, 0.0).value

            const output = this.round2(sum)
            return output
        },

        filteredPaymentTypes() {
            if (this.selectedDocumentType && (this.selectedDocumentType.id ?? 0) > 0) {
                // console.log(`selected document inert: ${selectedDocumentType.inert}`)

                if (this.selectedDocumentType.updates_ledger == false)
                    return this.paymentTypes.filter(x => x.flag_credit == true)
                
                return this.paymentTypes
            }
                
        },
        
        totalChargedAmountSummary() {
            
            let chargedAmount = this.totalChargedAmount

            if (this.selectedPaymentType && chargedAmount)
                return `(${this.selectedDocumentType.payable ? this.selectedPaymentType.description : "ΠΙΣΤΩΣΗ"}) ${chargedAmount}`
        },

        selectedRowsBranchIds() {
            return this.selectedRows?.map(x => x.account_branch_id)
        },

        selectedRowsWarehouseIds() {
            return this.selectedRows?.map(x => x.warehouse_id)
        },

        stepCompleted() {
            switch (this.step) {

                case 0:
                    if ((this.selectedRows?.length > 0) == false)
                        return false

                    if ((new Set(this.selectedRowsBranchIds).size == 1) == false)
                        return false

                    if ((new Set(this.selectedRowsWarehouseIds).size == 1) == false)
                        return false

                    break

                case 1:
                    if (!this.selectedDocumentType.id)
                        return false
                    
                    if (!this.selectedSeries.id)
                        return false
                    
                    if (!this.document_issue_date)
                        return false

                    if (this.selectedSeries.autonumbered == false && (this.document_number.toString().length > 0 == false))
                        return false
                    
                    break

                case 2:
                    if (this.selectedDocumentType.payable == true && ((this.selectedPaymentType.id ?? 0 > 0) == false))
                        return false

                    if (this.totalChargedAmount > 0 == false)
                        return false

                    const reducer = (a, b) => a && b;

                    if (this.items.map(x => x.total_price > 0).reduce(reducer, true) == false)
                        return false;

                    break

                default:
                    return true
            }
        },

        lineEntryIncomplete() {
            let isLineOk = 
                ((this.editedItem.quantity ?? 0) > 0) 
                && ((this.editedItem.unit_price ?? 0) > 0)
                && (
                    (
                        (this.editedItem.product_id ?? 0 > 0)
                        || (
                                (this.editedItem.product_id ?? 0 == 0)
                                && this.editedItem.override_product_description?.length > 0
                                && this.editedItem.override_product_vat_category_id > 0
                                && this.editedItem.override_product_measurement_unit_id > 0
                            )
                    )
                )
                
            return isLineOk == false;
        },
    },


    methods: {
        debugItems() {
            console.log(this.totalChargedAmount)

            const reducer = (a, b) => (currency(a).add(b))

            const blabla = this.round2(this.items.map(x => x.total_price - x.discount).reduce(reducer, 0.0).value)


            console.log(blabla)
        },

        nextStep() {
            this.scroll2top()

            this.step++;

            if (this.step == 2 && this.items.length == 0)
            {
                console.log('adding items')
                // const lines = this.selectedRows.flatMap(x => x.lines)
                
                // for (let i = 0; i < lines.length; i++)
                //     this.items.push(this.mixmatch(lines[i]))


                for (let i = 0; i < this.selectedRows.length; i++)
                {
                    const document = this.selectedRows[i]
                    const lines = document.lines
                    for (let j = 0; j < lines.length; j++)
                    {
                        let item = lines[j];
                        item.document = `${document.series.name} #${document.document_number}`
                        item.quantity = parseFloat(item.quantity)
                        
                        delete item.tax_value
                        delete item.net_value
                        
                        this.items.push(this.mixmatch(item))
                    }
                }
            }
        },

        makeCurrency (a) {
            return currency(a)
        },

        productSelected(newValue) {
            const product = this.products.find(x => x.id == newValue)

            this.editedItem.override_product_description = product.description
            this.editedItem.override_product_vat_category_id = product.vat_category_id
            this.editedItem.override_product_measurement_unit_id = product.measurement_unit_id
            this.editedItem.override_product_vat_exemption_category_id = product.vat_exemption_category_id ?? 0
            this.editedItem.override_product_tax_withholding_category_id = product.tax_withholding_category_id ?? 0
            this.editedItem.override_product_income_category_id = product.income_category_id
        },

        adHocItemStatusChanged(newValue) {
            // this.editedItem = {
            //     ...this.defaultItem,
            //     isAdHoc: newValue
            // }

        },


        mixmatch (item) {
            // if (item.isAdHoc)
            //     item.product_id = 0

            // console.log(item)

            item.unit_price = parseFloat(item.unit_price) 
            item.discount_percentage = parseFloat(item.discount_percentage ?? 0)

            if (item.product_id > 0)
                item.product = this.products.find(prd => prd.id == item.product_id)
            else
                item.product = {
                  code: '-',
                  description: item.override_product_description  
                } 

            

            item.discount = 0

            item.total_price = this.round2(item.quantity * item.unit_price)

            if (item.discount_percentage > 0)
                item.discount = this.round2(item.total_price * (item.discount_percentage * 0.01))


            return item;
        },

        round2(number, toFixed = false) {
            const rounded = Math.round( number * 100 + Number.EPSILON ) / 100

            if (toFixed)
                return rounded.toFixed(2)

            return rounded
        },

        scroll2top() {
            goTo(0)
        },

        initialize() {
            this.$store.dispatch('currentUser/getCurrentUser')

            // this.document_issue_date = new Date().toISOString().slice(0, 10)

            const dateAthens = new Intl.DateTimeFormat('en-CA', {
                timeZone: 'Europe/Athens',
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
            }).format(new Date());

            this.document_issue_date = dateAthens;

            axios.all([
                axios.get('/api/document-types/sales'),
                axios.get('/api/tax-authority/payment-types'),
                axios.get('/api/documents/warehouse/standing-sales')
            ]).then(
                axios.spread(
                (
                    documentTypesResponse, 
                    paymentTypesResponse,
                    standingDocumentsResponse
                ) => {
                    const documentTypeSorter = (a, b) => a.debit === b.debit ? a.description.localeCompare(b.description) : (a.debit ? -1 : 1)

                    this.documentTypes = documentTypesResponse.data.filter(x => x.updates_stock == false).sort(documentTypeSorter)
                    
                    this.paymentTypes = paymentTypesResponse.data
                    
                    this.accounts = standingDocumentsResponse.data.accounts
                    this.documents = standingDocumentsResponse.data.documents

                    const lines = this.documents.flatMap(x => x.lines)
                    const products = lines.map(x => x.product)

                    const uniqueProducts = []

                    products.forEach(function (product) {
                        if (uniqueProducts.filter(x => x.id === product.id).length > 0)
                            return
                        uniqueProducts.push(product)
                    })

                    this.products = uniqueProducts

            })).catch(error => { console.log(error) })

            this.editedItem = Object.assign({}, this.defaultItem)
        },


        editItem (item) {
            // console.log(item)
            // console.log(this.editedItem)
            this.editedIndex = this.items.indexOf(item)
            this.editedItem = Object.assign({}, item)
            
            this.dialog = true

        },

        close () {
            this.dialog = false

            this.editedItem = Object.assign({}, this.defaultItem)
            this.editedIndex = -1

            // this.$nextTick(() => {
            //     this.editedItem = Object.assign({}, this.defaultItem)
            //     this.editedIndex = -1
            // })
        },

        closeDelete () {
            this.dialogDelete = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
            })
        },

        save (closeDialog = true) {
            const newItem = this.mixmatch(this.editedItem); 
            this.items.splice(this.editedIndex, 1, newItem)
          
            if (closeDialog)
                this.close();
        },


        saveDocument() {
            this.saveDocumentButtonDisabled = true;

            let requestBody = {
                warehouse_document_ids: this.selectedRows.map(x => x.id),
                document_type_id: this.selectedDocumentType.id,
                document_series_id: this.selectedSeries.id,
                document_issue_date: this.document_issue_date,
                document_number: this.document_number,
                customer_id: this.selectedAccount.id,
                customer_branch_id: this.selectedRowsBranchIds.pop(),
                warehouse_id: this.selectedRowsWarehouseIds.pop(),
                
                payment_type_id: this.selectedDocumentTypeIsPayable ? this.selectedPaymentType.id : this.paymentTypes.find(x => x.flag_credit == true).id,
                productLines: this.items.map(x => {
                    let productLine = { 
                        product_id : x.product_id, 
                        quantity: x.quantity, 
                        unit_price: x.unit_price,
                        discount: x.discount,
                        discount_percentage: x.discount_percentage,
                        total_price: x.total_price
                    } 

                    if (x.override_product_description?.length > 0)
                        productLine.override_product_description = x.override_product_description;

                    return productLine
                }),
                
                comments: (this.comments.length ?? '' > 0) ? this.comments : null,
                comments2: (this.comments2.length ?? '' > 0) ? this.comments2 : null,
            }


            axios.post('/api/documents/sales/fromWarehouseDocuments', requestBody)
            .then(_ => { 
                this.$router.push({ name: 'salesdocuments' })
            })
            .catch(error => { 
                console.log(error)
                
                // if (error.response.data)
                //     if (errors.response.data.errors)
                //         this.allerrors = error.response.data.errors
              })
            .finally( () => { this.saveDocumentButtonDisabled = false })
        },

        async searchAccountByTaxRegistrationNumber(accountPropertyName) {

            if (this.disabledTaxRegistrationNumberFields[accountPropertyName] == true)
                return

            this.disabledTaxRegistrationNumberFields[accountPropertyName] = true

            let needle = this[accountPropertyName].tax_registration_number
            let response = await axios.get(`/api/accounts/search/tax-registration-number/${needle}`)

            this.disabledTaxRegistrationNumberFields[accountPropertyName] = false
            
            if (response.data.length == 1) {
                let account = response.data[0]

                this.updateAccount(accountPropertyName, account)
                
                if (account.tax_office && account.tax_office.code && this.taxOffices.filter(taxOffice => taxOffice.code == account.tax_office.code).length > 0 == false) {
                    //this.taxOffices.push(account.tax_οffice)
                    axios.get('/api/tax-offices')
                    .then(response => this.taxOffices = response.data)
                }
            } else if (response.data && response.data.length > 1) {
                this.selectAccountDialogEntries = response.data
                this.selectAccountDialogShownFor = accountPropertyName
                this.selectAccountDialog = true
            } else {
                this.$swal({
                    icon: 'warning',
                    title: 'Δεν βρέθηκε',
                    text: 'Το ΑΦΜ δεν βρέθηκε στη βάση δεδομένων ούτε στο μητρώο της ΑΑΔΕ (ελέγξτε αν είναι σωστό).'
                });
            }
            
        },

        async searchAccountByName(accountPropertyName) {
            let needle = this[accountPropertyName].name
            let response = await axios.get(`/api/accounts/search/name/${needle}`)

            if (response.data.length == 1)
                this.updateAccount(accountPropertyName, response.data[0])
            else if (response.data.length > 1) {

                this.selectAccountDialogEntries = response.data
                this.selectAccountDialogShownFor = accountPropertyName
                this.selectAccountDialog = true
            }
        },

        closeSelectAcountDialog() {
            this.selectAccountDialog = false
            this.selectAccountDialogEntries = []
            this.selectAccountDialogShownFor = null
        },

        updateAccount(accountPropertyName, data) {
            this[accountPropertyName] = {
                id: data.id,
                address : data.address,
                name : data.name,
                city : data.city,
                telephone : data.telephone,
                fax : data.fax,
                email : data.email,
                country_id : data.country_id,
                mobile : data.mobile,
                tax_registration_number: data.tax_registration_number,
                zipcode: data.zipcode,
                tax_registration_office_id: data.tax_registration_office_id,
                jobtitle: data.jobtitle
            }
        }
            //.catch(error => { console.log(error) })
    }
}
</script>

<style scoped>

</style>